import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/customer/layout/about")({
  component: About,
});

function About() {
  return (
    <>
      <div className="p-2 flex-auto">
        <h3>Welcome dawdawdHomde!</h3>
      </div>
    </>
  );
}
